<template>
  <div>
    <div v-if="!hasData" class="caption grey--text py-3">No score data in this period.</div>
    <svg v-else viewBox="0 0 300 110" width="100%" preserveAspectRatio="none" style="display:block;max-height:140px">
      <line x1="0" y1="100" x2="300" y2="100" stroke="#e0e0e0" stroke-width="1" />
      <line x1="0" y1="50" x2="300" y2="50" stroke="#f0f0f0" stroke-width="1" />
      <polyline v-for="(seg, i) in segments" :key="'s' + i" :points="seg" fill="none" :stroke="color" stroke-width="2" vector-effect="non-scaling-stroke" />
      <circle v-for="p in points" :key="p.label" :cx="p.x" :cy="p.y" r="3" :fill="color">
        <title>{{ p.label }}: {{ p.score }}</title>
      </circle>
    </svg>
    <div v-if="hasData" class="d-flex justify-space-between caption grey--text">
      <span>{{ buckets[0].label }}</span>
      <span v-if="buckets.length > 1">{{ buckets[buckets.length - 1].label }}</span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AdminTrendChart',
  props: {
    buckets: { type: Array, default: () => [] },
    color: { type: String, default: '#1976d2' },
  },
  computed: {
    hasData() {
      return this.buckets.some(b => b.growth_score !== null && b.growth_score !== undefined)
    },
    points() {
      const n = this.buckets.length
      return this.buckets
        .map((b, i) => ({
          label: b.label,
          score: b.growth_score,
          x: n === 1 ? 150 : 8 + (i * 284) / (n - 1),
          y: 100 - Math.max(0, Math.min(100, b.growth_score || 0)),
        }))
        .filter(p => p.score !== null && p.score !== undefined)
    },
    // Break the line at null buckets so gaps are not drawn as zero.
    segments() {
      const segs = []
      let cur = []
      const n = this.buckets.length
      this.buckets.forEach((b, i) => {
        if (b.growth_score === null || b.growth_score === undefined) {
          if (cur.length > 1) segs.push(cur.join(' '))
          cur = []
          return
        }
        const x = n === 1 ? 150 : 8 + (i * 284) / (n - 1)
        cur.push(`${x},${100 - Math.max(0, Math.min(100, b.growth_score))}`)
      })
      if (cur.length > 1) segs.push(cur.join(' '))
      return segs
    },
  },
}
</script>
